/*
 * Tencent is pleased to support the open source community by making TMagicEditor available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { InstallOptions } from '@editor/type';

let $TMAGIC_EDITOR: InstallOptions = {} as any;

const setConfig = (option: InstallOptions): void => {
  $TMAGIC_EDITOR = option;
};

const getConfig = (key: keyof InstallOptions): unknown => $TMAGIC_EDITOR[key];

export { getConfig, setConfig };
